import { http } from '../utils/http';

export function getSlope(signal) {
    return http.get('/slope.json', { signal });
}
